import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/comics';

export default function Footer() {
  const quickLinks = [
    { name: '首页', href: '/' },
    { name: '全部分类', href: '/category/all' },
    { name: '关于我们', href: '/about' },
    { name: '热门漫画', href: '/category/all' },
  ];

  const categoryLinks = categories.filter(c => c.slug !== 'all').slice(0, 6);

  return (
    <footer className="bg-background-900" role="contentinfo">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-white"></i>
              </div>
              <span className="text-lg font-heading text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              {siteInfo.slogan}
            </p>
            <p className="text-foreground-400 text-xs mt-3 leading-relaxed">
              为广大漫画爱好者提供高品质、无删减的免费漫画阅读服务，下拉式阅读设计，流畅的观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信：{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-qq-line text-primary-400"></i>
                <span>QQ群：{siteInfo.qq}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-400 text-xs">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}